import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Flex, Container, Box, Text, List, Spinner } from "samba-ui";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import { loadOutages, updateOutages } from "../redux/outages";
import AreYouSureModal from "./AreYouSureModal";

const ManageOutages = ({ outages, loadOutages, updateOutages }) => {
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    const req = async () => {
      setLoading(true);
      await loadOutages();
      setLoading(false);
    };
    req();
  }, [loadOutages]);

  const onToggleChange = async (e, application) => {
    e.persist();
    const { checked } = e.target;
    const status = checked ? "warning" : "normal";
    setSelected({ status, application });
    setIsOpen(true);
  };

  const onSubmit = async () => {
    const { application, status } = selected;
    setLoading(true);
    await updateOutages(application, { status });
    setLoading(false);
    setIsOpen(false);
    setSelected({});
  };

  return (
    <Container maxWidth={2048} minWidth={960}>
      <Flex>
        <Box width={3 / 4} mr={4}>
          <List.Header borderColor="#d6d6d6 !important">
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize={1} color="secondary">
                Outages
              </Text>
            </Flex>
          </List.Header>
          {loading ? (
            <List.Item borderColor="#d6d6d6 !important">
              <Flex justifyContent="center">
                <Spinner variant="medium" />
              </Flex>
            </List.Item>
          ) : (
            outages &&
            Object.keys(outages).map(id => (
              <List.Item
                borderColor="#d6d6d6 !important"
                key={outages[id].application}
              >
                <Flex alignItems="center" justifyContent="space-between">
                  <Text fontSize={1} color="palette.ink.normal">
                    {outages[id].application}
                  </Text>
                  <Box>
                    <Toggle
                      checked={outages[id].status !== "normal"}
                      onChange={e => onToggleChange(e, outages[id].application)}
                    />
                  </Box>
                </Flex>
              </List.Item>
            ))
          )}
        </Box>
      </Flex>
      <AreYouSureModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setSelected({});
        }}
        title="Are you sure?"
        body="Are you sure you want to update the status of the application?"
        onSubmit={onSubmit}
      />
    </Container>
  );
};

ManageOutages.propTypes = {
  outages: PropTypes.object,
  loadOutages: PropTypes.func,
  updateOutages: PropTypes.func
};

const mapStateToProps = (state, props) => ({
  outages: state.outages
});

const mapDispatchToProps = dispatch => ({
  loadOutages: () => dispatch(loadOutages()),
  updateOutages: (application, body) =>
    dispatch(updateOutages(application, body))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageOutages);
